import React, { createContext, useState } from "react";

export const AppProvider = (props) => {
  const { Provider } = AppContext;

  const [itemSnapped, setItemSnapped] = useState("");

  return (
    <Provider value={[itemSnapped, setItemSnapped]}>{props.children}</Provider>
  );
};

export const AppContext = createContext();
